import { g as d } from "../../utils-BOfnFgIH.js";
import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as o, normalizeClass as s, createElementVNode as a } from "vue";
import { _ as m } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const u = {
  name: "DtIconFilm",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(l).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], f = ["clip-path"], h = ["id"];
function p(e, i, r, v, H, t) {
  return n(), o("svg", {
    "aria-label": r.ariaLabel,
    class: s([t.iconSizeClass, "d-icon d-icon--film"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Film",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, [...i[0] || (i[0] = [
      a("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M2.09.5A1.59 1.59 0 0 0 .5 2.09v7.82c0 .878.712 1.59 1.59 1.59h7.82a1.59 1.59 0 0 0 1.59-1.59V2.09A1.59 1.59 0 0 0 9.91.5H2.09ZM4 5.5v-4h4v4H4Zm6.5 0H9V4h1.5v1.5Zm0-3.41a.59.59 0 0 0-.59-.59H9V3h1.5v-.91Zm0 5.91H9V6.5h1.5V8Zm-.59 2.5a.59.59 0 0 0 .59-.59V9H9v1.5h.91ZM1.5 2.09a.59.59 0 0 1 .59-.59H3V3H1.5v-.91ZM3 4H1.5v1.5H3V4ZM1.5 6.5H3V8H1.5V6.5Zm0 3.41c0 .326.264.59.59.59H3V9H1.5v.91ZM8 6.5v4H4v-4h4Z",
        fill: "currentColor"
      }, null, -1)
    ])], 8, f),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...i[1] || (i[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, h)
    ])
  ], 10, c);
}
const I = /* @__PURE__ */ m(u, [["render", p]]);
export {
  I as default
};
//# sourceMappingURL=film.js.map
